import { observer } from 'mobx-react';
import moment from 'moment';

import _ from 'lodash';

import { ApiMixin } from "./ApiMixin";
import { TimestampApi } from "../../util/api/TimestampApi";



//Returns the student object, plus some helper functions
class Timestamp {
    in : null;
    out : null;
    lunchIn : null;
    lunchOut : null;

    date : null;
    dayName : null;

    inObject : false;
    outObject : false;
    lunchInObject : false;
    lunchOutObject : false;


    constructor(timestamp = {}) {
        //Adds any default values passed by the developer 
        _.defaults(this, timestamp);

        ApiMixin(this, TimestampApi);
    }

    mutate(timestamp = {}) {

        if (timestamp.date) {
            this.dayName = timestamp.date.format('dddd')
        }

        //This takes all matching keys from the timestamp and assigns them to this object 
        _.assign(this, _.pick(timestamp, _.keys(this)));

    }

    get inObject() {
        return this.in ? moment(this.in) : null;
    }

    get outObject() {
        return this.out ? moment(this.out) : null;
    }

    get lunchInObject() {
        return this.lunchIn ? moment(this.lunchIn) : null;
    }

    get lunchOutObject() {
        return this.lunchOut ? moment(this.lunchOut) : null;
    }

    hourDisplay(timestamp) {
        if(timestamp) {
            const hour = timestamp.split("T")[1].split(":")[0]
            const minute = timestamp.split("T")[1].split(":")[1]

            let retval = hour + ":" + minute
            
            const hourInt = parseInt(hour);
            console.log(hourInt)

            if (hourInt <= 11) {
                retval += "am"
            }
            else {
                retval += "pm"
            }
    
            return retval;
        }
        return "N/A"
    }
}

//observer(Timestamp);

export default Timestamp;
